
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { validationMixin } from "vuelidate";
import AppLoading from "@/components/UI/AppLoading.vue";
import { required, minLength, minValue } from "vuelidate/lib/validators";

export default Vue.extend({
  name: "CreateFooterAddressComponent",
  mixins: [validationMixin],
  components: { AppLoading },
  data() {
    return {
      chosenFile: "" as string | FormData,
      chosenFiles: "" as string | FormData,
      defaultImage: require("@/assets/img/default-product.jpg"),
    };
  },
  methods: {
    submitContent() {
      const data = store.state.admin.landing.factoryAddress;
      store.dispatch("admin/submitCreateFactoryAddress", data);
    },
  },
  computed: {
    languages(): any[] {
      let items: any[] = [
        {
          title: "انگلیسی",
          value: "En",
        },
        {
          title: "فارسی",
          value: "Fa",
        },
        {
          title: "عربی",
          value: "Ar",
        },
      ];
      return items;
    },

    address: {
      get(): string {
        return store.state.admin.landing.factoryAddress.address;
      },
      set(value: string): void {
        store.dispatch("admin/updateFactoryAddressAddress", value);
      },
    },

    addressError(): string[] {
      const errors: string[] = [];
      if (!this.$v.address?.$dirty) {
        return errors;
      }
      !this.$v.address.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    language: {
      get(): string {
        return store.state.admin.landing.factoryAddress.language;
      },
      set(value: any): void {
        store.dispatch("admin/updateFactoryAddressLanguage", value);
      },
    },
    languageError(): string[] {
      const errors: string[] = [];
      if (!this.$v.language?.$dirty) {
        return errors;
      }
      !this.$v.language.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    isLoading(): boolean {
      return store.state.app.loading;
    },
  },
  mounted() {
    const id = this.$route.query.id;
    if (id) {
      store.dispatch("admin/updateProductCategory", id);
    }
  },
  validations: {
    address: {
      required,
    },
    language: {
      required,
    },
  },
});
